<template>
  <component :is="way" v-bind="{ ...$props, ...$attrs }" v-on="$listeners" />
</template>

<script>
import PROCESS_NAMES from '@/process/names';
import {STORE_PREFIX} from '../../constants.js';
import StageDefault from './default.vue'
const StageDanone = () => import(/* webpackChunkName: "danone" */'@/process/danone/components/interview/components/stage/index.vue');
const StageSiburTest = () => import(/* webpackChunkName: "sibur-test" */'@/process/sibur-test/components/interview/components/stage/index.vue');
const StageBcgTest = () => import(/* webpackChunkName: "bcg-test" */'@/process/bcg-test/components/interview/components/stage/index.vue');
const StageFeniche = () => import(/* webpackChunkName: "feniche-stage" */'@/process/feniche/common/components/interview/components/stage');

export default {
  name: 'stage',

  components: {
    StageDefault,
    StageDanone,
    StageBcgTest,
    StageSiburTest,
    StageFeniche
  },

  props: [
    'item',
    'companyInfo',
    'activeModules',
    'isDisabled',
    'loading',
    'interview',
    'isVideoresume',
    'isResumeMandatory',
    'isResumeFinished',
    'hasValidResume'
  ],

  computed: {
    way() {
      let way = 'stage';
      const process = this.$store.getters[STORE_PREFIX + 'interview/process']
        || this.$store.getters['landing/process']

      if (process === PROCESS_NAMES.DANONE
        || process === PROCESS_NAMES.BCG_TEST
        || process === PROCESS_NAMES.SIBUR_TEST
        || process === PROCESS_NAMES.FENICHE) {
        return `${way}-${process}`;
      } else {
        return `${way}-default`;
      }
    }
  }
}
</script>
